import { render, staticRenderFns } from "./Form18.vue?vue&type=template&id=bb546126&scoped=true"
import script from "./Form18.vue?vue&type=script&lang=ts"
export * from "./Form18.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=bb546126&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb546126",
  null
  
)

export default component.exports